<template>
    <b-navbar id="myNavbar"  toggleable="xl" type="dark" variant="info" class="px-4" v-if="$store.getters.isAuth">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <b-img :src="require('../assets/img/hskz.png')" fluid alt="eTicket" />
        <span class="px-2" style="color: white">eGate.io</span>

        <b-collapse is-nav id="nav_collapse" ref="nav_collapse" >
            <b-navbar-nav>
                    <template v-for="(item, index) in navItems" v-if="$store.getters.isAuth">
                        <li class="sidebar-link" v-if="$store.getters.isAuth && isMobile()">
                            <router-link :to="item.href"
                                         v-b-toggle="'nav_collapse'"
                                         class="d-flex justify-content-between">
                                <div>
                                    {{ $t(item.title)}}
                                </div>
                            </router-link>
                        </li>
                        <div v-if="index < navItems.length" class="separator"></div>
                    </template>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto profile">
                <b-nav-item-dropdown right v-if="$store.getters.isAuth">
                    <!-- Using button-content slot -->
                    <template slot="button-content">
                        <span v-if="$parent.currentUser">{{$parent.currentUser.username}} - </span>
                        <em><i class="fas fa-user"></i></em>
                    </template>
                    <b-dropdown-item v-if="$parent.currentUser && $parent.currentUser.role === 'administrator'">
                        <router-link
                        v-if="$parent.currentUser.role === 'administrator'"
                                to="/auth/register">
                                <span class="flex-center">{{ $t('dropdown.add')}}</span>
                        </router-link>
                    </b-dropdown-item>
                    <div class="separator"></div>
                    <b-dropdown-item>
                        <router-link
                                to="/profile">
                                <span class="flex-center">{{ $t('dropdown.profile')}}</span>
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item @click="logout">
                        <span class="flex-center">
                            {{$t('dropdown.logout')}}
                        </span>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown right :text="$store.getters.currentLang">
                    <template slot="button-content">
                        <em><i class="fas fa-globe-europe"></i></em>
                    </template>
                <b-dropdown-item @click="changeLang('en')"> 
                    <span class="flex-center">EN - English</span>
                </b-dropdown-item>
                <b-dropdown-item @click="changeLang('hr')">
                    <span class="flex-center">HR - Hrvatski</span>
                </b-dropdown-item>
            </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>

</template>

<script>
    export default {
        name: 'navbar',
        props: {
            items: {
                type: Object,
                default: null
            }
        },
        computed: {
            navItems() {
                if (this.$parent.currentUser === null) {
                    return this.items.guest;
                }
                switch (this.$parent.currentUser.role) {
                    case 'administrator':
                        return this.items.admin;
                    case 'sales':
                        return this.items.sales;
                    case 'guest':
                        return this.items.guest;
                    default: this.items.guest;
                }
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
            logout() {
                localStorage.clear();
                this.$store.dispatch('logout');
                this.$router.push('/auth/login');
            },
            isMobile(){
                let width  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                if(width <1200 ) {
                    return true;
                }
                else return false;
            },
            changeLang(lang){
                this.$axios.post('/changeLang', {
                        lang: lang,
                        id: this.$parent.currentUser.id
                }).then(res =>{
                    let currentUser = this.$store.getters.currentUser;
                    currentUser.lang = lang;
                    this.$store.dispatch('changeLang', lang)
                })
                this.$i18n.locale = lang
            }
        },
        destroyed(){
            clearInterval(this.interval);
        },
    }
</script>

<style lang="scss">

    #myNavbar {
        width: 100%;
        min-height: 70px;
        //background-image: url('../assets/img/login.jpg') !important;

        background: #0F2027;

        // background: -webkit-linear-gradient(to left, #2C5364, #203A43, #0F2027);  /* Chrome 10-25, Safari 5.1-6 */
        // background: linear-gradient(to left, #2C5364, #203A43, #0F2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

        background-image: linear-gradient( 108deg,  rgba(2,93,145,1) 17.3%, rgba(0,156,222,1) 77.6% );
        img {
            max-height: 40px;
        }

    }

    .profile{
        a{
            color: #000;
        }
    }
    
    .sidebar {
        .dropdown-menu {
            background-image: url('../assets/img/login.jpg') !important;
            padding: 8px 16px;
        }
    }


    .sidebar-link {
        font-size: 1em !important;
        min-width: 300px;
    }

    .submenu-link {
        font-size: 0.9em !important;
    }

    .sidebar-link, .submenu-link {
        margin: 8px 0;
        a {
            padding: 10px 10px;
            color: #000!important;
        }
        a.active {
            font-weight: 700;
            text-decoration: underline;
        }
    }

    .separator{
        height: 2px;
        background: #000;
        margin: 0 10px;
    }


</style>

